import { render, staticRenderFns } from "./MenuItemsIterator.vue?vue&type=template&id=7a548fbd&"
import script from "./MenuItemsIterator.vue?vue&type=script&lang=ts&"
export * from "./MenuItemsIterator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports